export default function () {
  const FAVICON_SVG_URL = 'https://assets.zenvia.com/images/favicon/favicon-adaptive.svg'
  let svgFaviconLink = null
  let mediaQuery = null

  const updateFavicon = () => {
    if (!svgFaviconLink) return

    const newLink = document.createElement('link')
    newLink.rel = 'icon'
    newLink.type = 'image/svg+xml'
    newLink.sizes = 'any'
    newLink.href = `${FAVICON_SVG_URL}?t=${Date.now()}`

    svgFaviconLink.remove()

    const firstLink = document.head.querySelector('link')
    if (firstLink) {
      document.head.insertBefore(newLink, firstLink)
    } else {
      document.head.appendChild(newLink)
    }

    svgFaviconLink = newLink
  }

  const init = () => {
    const supportsSVGFavicon = () => {
      const link = document.createElement('link')
      return link.relList && link.relList.supports && link.relList.supports('icon')
    }

    if (!supportsSVGFavicon()) {
      return
    }

    svgFaviconLink = document.createElement('link')
    svgFaviconLink.rel = 'icon'
    svgFaviconLink.type = 'image/svg+xml'
    svgFaviconLink.sizes = 'any'
    svgFaviconLink.href = FAVICON_SVG_URL

    const firstLink = document.head.querySelector('link')

    if (firstLink) {
      document.head.insertBefore(svgFaviconLink, firstLink)
    } else {
      document.head.appendChild(svgFaviconLink)
    }

    mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', updateFavicon)
    } else {
      // Fallback for older browsers
      mediaQuery.addListener(updateFavicon)
    }
  }

  const destroy = () => {
    if (mediaQuery) {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', updateFavicon)
      } else {
        mediaQuery.removeListener(updateFavicon)
      }
    }

    if (svgFaviconLink) {
      svgFaviconLink.remove()
    }
  }

  const getCurrentTheme = () => (mediaQuery && mediaQuery.matches ? 'dark' : 'light')

  return {
    init,
    destroy,
    getCurrentTheme,
  }
}
